import styled from 'styled-components';
import withColor from 'util/hoc/with-color';

export const StyledCareerClustersLandingContainer = withColor(styled.div`
  max-width: 600px;
  height: 681px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  h2 {
    font-size: 28px;
    font-weight: bold;
    line-height: 38px;
  }
  p {
    line-height: 22px;
    font-weight: 400;
    span {
      font-weight: 300;
    }
    a {
      color: ${props=>props.colors.secondary};
      text-decoration: none;
      font-weight: bold;
    }
  }
`);


export const StyledSurveyOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 1em;
  justify-content: center;
  p {
    text-align: center;
    width: 100%;
  }
`;

export const StyledGetStartedButton = styled.button`
  background: ${ props => props.background || 'none' };
  text-decoration: none;
  border-radius: 4px;
  width: ${props => props.width || '300px'};
  height: 48px;
  color: ${props => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 17px;
  align-self: center;
  padding: 0;
  text-transform: none;
  background: ${props => props.background};
  border: ${props => props.border};
  margin-bottom: 2em;
`;
